import Vue from "vue";

Vue.mixin({
  methods: {
    representInThousandsFormat: (number) =>
      number.toLocaleString(undefined, {
        style: "decimal",
        maximumFractionDigits: 2,
        minimumFractionDigits: 0,
      }),

    //     isWishListed(product_id) {
    //         return this.$store.getters.getIsWishListed(product_id);
    //     },
    //     addToWishList(product_id) {
    //         let json_data = {};
    //         json_data["wish_product"] = product_id;
    //         if (!this.$store.getters.isAuthenticated) {
    //             let json_data = {};
    //             json_data["product_id"] = product_id;
    //             json_data["action"] = "wishlist";
    //             this.constructMetaInfoAndNavigate(json_data, product_id);
    //         } else {
    //             this.$store.dispatch("addToWishList", json_data).then(res => {
    //                 this.$store.commit("appendToWishList", res);
    //             });
    //         }
    //     },
    //     removeFromWishList(product_id) {
    //         this.$store.dispatch("deleteFromWishList", product_id).then(res => {
    //             this.$store.commit("deleteFromWishList", product_id);
    //         });
    //     },
    //     constructMetaInfoAndNavigate(metaInfo, product_id) {
    //         let navigateBackTo = this.$store.state.navigateBackTo;
    //         navigateBackTo.required = true;
    //         navigateBackTo.url = `/product/${product_id}/`;
    //         navigateBackTo.metaInfo = metaInfo;

    //         this.$router.push("/login/");
    //     },

    //     upVote(product_id) {
    //         if (this.$store.getters.isAuthenticated) {
    //             this.$store
    //                 .dispatch("upVote", product_id)
    //                 .then(res => {
    //                     this.total_vote_count = res.upvote_count;
    //                     this.voted = true;
    //                 })
    //                 .catch(err => {
    //                     this.loading = false;
    //                     this.$notify({
    //                         group: "error",
    //                         title: "Error",
    //                         text: "Something Went Wrong",
    //                     });
    //                 });
    //         } else {
    //             let json_data = {};
    //             json_data["product_id"] = product_id
    //             json_data["action"] = "upvote";
    //             this.constructMetaInfoAndNavigate(json_data, product_id);
    //         }
    //     },
    //     downVote(product_id) {
    //         this.$store
    //             .dispatch("downVote", product_id)
    //             .then(res => {
    //                 this.total_vote_count = res.upvote_count;
    //                 this.voted = false;
    //             })
    //             .catch(err => {
    //                 this.loading = false;
    //                 this.$notify({
    //                     group: "error",
    //                     title: "Error",
    //                     text: "Something Went Wrong",
    //                 });
    //             });
    //     },
  },
});
